// extracted by mini-css-extract-plugin
module.exports = {"hotel-info-window":"clustered-hotel-markers_component_hotel-info-window__A3Qfe","hotel-info-header":"clustered-hotel-markers_component_hotel-info-header__WM13k"};